import React from 'react';
import { Stack, StackProps } from '@hover/blueprint';
import { Link } from '@chakra-ui/react';
import { INavbarItem } from '../../../interfaces/INavbarItems';
import AppleBadge from '../../../assets/images/app-badge-apple.svg';
import AndroidBadge from '../../../assets/images/app-badge-google.svg';

export interface IFooterNavbarProps extends StackProps {
  appURLs: {
    googlePlay?: string;
    appstore?: string;
  };
  navbarItems: Omit<INavbarItem, 'children'>[];
}

const FooterNavbar = ({
  appURLs,
  navbarItems,
  ...stackProps
}: IFooterNavbarProps) => (
  <Stack
    alignItems="center"
    textAlign="center"
    direction={{ base: 'column', tablet: 'row' }}
    {...stackProps}
  >
    <Stack
      direction="row"
      mr="auto"
      ml={{ base: 'auto', tablet: 'initial' }}
      mb={{ base: 4, tablet: 0 }}
    >
      {appURLs.appstore && (
        <Link href={appURLs.appstore}>
          <AppleBadge alt="Badge Apple" style={{ width: 135, height: 40 }} />
        </Link>
      )}
      {appURLs.googlePlay && (
        <Link href={appURLs.googlePlay}>
          <AndroidBadge alt="Badge Google" style={{ width: 135, height: 40 }} />
        </Link>
      )}
    </Stack>
    <Stack
      direction={{ base: 'column', tablet: 'row' }}
      gap={{ base: 4, tablet: 6 }}
      ml="auto"
    >
      {navbarItems.map(item => (
        <Link
          href={item.to}
          key={item.label}
          fontSize={200}
          color="neutral.900"
        >
          {item.label}
        </Link>
      ))}
    </Stack>
  </Stack>
);

export default FooterNavbar;
